import { render, staticRenderFns } from "./entrepreneurshipsIndicator.vue?vue&type=template&id=09d1a36a&scoped=true"
import script from "./entrepreneurshipsIndicator.vue?vue&type=script&lang=js"
export * from "./entrepreneurshipsIndicator.vue?vue&type=script&lang=js"
import style0 from "./entrepreneurshipsIndicator.vue?vue&type=style&index=0&id=09d1a36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1a36a",
  null
  
)

export default component.exports